import React from 'react';
import { Card } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

interface IEmptyState {
    classHolder: string;
    year?: number;
}

export default function EmptyStateSelfSevice({ classHolder, year }: IEmptyState) {
    return (
        <Card className={classHolder}>
            <Card.Body className="text-center">
                <h1>
                    <FaInfoCircle />
                </h1>
                <h6>Sorry, no data{year ? ` for ${year}` : ''}!</h6>
            </Card.Body>
        </Card>
    );
}
